/**
 * Theme store
 *
 * This store manages the theme of the application and when it changed it will apply the new theme to the website.
 */

import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useSettingsStore } from '@/stores/Settings'

export const useThemeStore = defineStore('theme', () => {
	const ss = useSettingsStore()
	const current = ref('EARTH')

	// Apply the theme when it changes
	watch(() => ss.settings.theme, () => {
		applyTheme()
	})

	/**
	 * Applies the current theme to the document
	 */
	function applyTheme() {
		if (current.value === ss.settings.theme) { return }
		current.value = ss.settings.theme

		// Remove the old if any
		const themeElement = document.getElementById('theme')
		if (themeElement) {
			document.getElementsByTagName('head')[0]?.removeChild(themeElement)
		}

		// Load CSS
		const link = document.createElement('link')

		link.href = `${ss.apiUrl}/pbx/app/settings/desktop/theme/${ss.settings.theme}?token=${ss.token}`
		link.type = 'text/css'
		link.rel = 'stylesheet'
		link.media = 'screen,print'
		link.id = 'skin'
		document.getElementsByTagName('head')[0]?.appendChild(link)

		// Remove the old if any
		const icoElement = document.getElementById('ico')
		if (icoElement) {
			document.getElementsByTagName('head')[0]?.removeChild(icoElement)
		}

		// Load FavIcon
		//     <link rel="icon" href="favicon.ico">
		const link2 = document.createElement('link')

		link2.href = `${ss.apiUrl}/pbx/app/settings/desktop/theme/${ss.settings.theme}/favicon.ico?token=${ss.token}`
		link2.rel = 'icon'
		link2.id = 'ico'
		document.getElementsByTagName('head')[0]?.appendChild(link2)
	}

	applyTheme()

	return { }
})
